import * as entities from '../entities'

import { locationSchema, POIScheme } from './schemas'

export const locationsSelector = entities.selectors.createEntitySelector(locationSchema)

export const createLocationByIdSelector = id => createSelector(locationsSelector, locations => locations[id])

//TODO There is identical selectors in src/map, these should be unified.
const idLocationSelector = (state, props) => props.locationId

export const locationSelector = entities.selectors.createDenormalizedSelector(idLocationSelector, locationSchema)

const idPOISelector = (state, props) => props.placeOfInterestId

export const placeOfInterestSelector = entities.selectors.createDenormalizedSelector(idPOISelector, POIScheme)
